<template>
  <v-container fluid pt-0 v-if="initialLoad">
    <v-dialog max-width="400" persistent v-model="deleteDialog.show">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                class="text-xs-center"
                xs12
                v-html="
                  $t('labels.deleteDialog') +
                  '<b>' +
                  this.deleteDialog.generatedPin +
                  '</b>'
                "
              >
              </v-flex>
              <v-text-field
                @keyup.enter="deleteDialogSave"
                :label="''"
                hide-details
                class="mt-3"
                outline
                required
                v-model="deleteDialog.enteredPin"
              ></v-text-field>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialogClose" color="error">{{
            $t('buttons.close')
          }}</v-btn>
          <v-btn @click="deleteDialogSave" color="success">{{
            $t('buttons.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row v-if="totalAll == 0" wrap>
      <div
        :style="{
          backgroundImage: 'url(' + publicPath + 'img/main-bg.jpg' + ')',
        }"
        class="empty-overlay"
      >
        <div class="empty-inner">
          <h1>{{ $t('labels.noResultsEvents') }}</h1>
          <p v-html="$t('labels.noResultsEventsDetails')"></p>
          <v-btn @click="addItem" class="primary" large>
            {{ $t('buttons.createNew') }}
          </v-btn>
        </div>
      </div>
    </v-layout>
    <v-layout justify-center row v-if="totalAll != 0" wrap>
      <v-flex xl8 lg10 pt-4>
        <v-layout row wrap>
          <v-flex>
            <span class="display-1 primary--text">{{
              $t('modules.events')
            }}</span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-text-field
            :label="$t('labels.search')"
            class="mr-2 ml-2 search-field"
            clearable
            outline
            prepend-inner-icon="fa-search"
            v-model="search"
          ></v-text-field>
          <v-flex pt-4 sm12>
            <v-card class="events-main-card" elevation="0">
              <v-layout class="events-buttons-header" row wrap>
                <v-btn
                  :class="{
                    'events-category-active': category == '',
                    'events-category': true,
                  }"
                  @click="selectCategory('')"
                >
                  {{ $t('buttons.all') }}</v-btn
                >
                <v-btn
                  :class="{
                    'events-category-active': category == 'completed',
                    'events-category': true,
                  }"
                  @click="selectCategory('completed')"
                >
                  {{ $t('buttons.completed') }}</v-btn
                >
                <v-btn
                  :class="{
                    'events-category-active': category == 'active',
                    'events-category': true,
                  }"
                  @click="selectCategory('active')"
                >
                  {{ $t('buttons.active') }}</v-btn
                >
                <v-btn
                  :class="{
                    'events-category-active': category == 'published',
                    'events-category': true,
                  }"
                  @click="selectCategory('published')"
                >
                  {{ $t('buttons.published') }}</v-btn
                >
                <v-btn
                  :class="{
                    'events-category-active': category == 'draft',
                    'events-category': true,
                  }"
                  @click="selectCategory('draft')"
                >
                  {{ $t('buttons.drafts') }}</v-btn
                >
                <v-btn
                  :class="{
                    'events-category-active': category == 'archive',
                    'events-category': true,
                  }"
                  @click="selectCategory('archive')"
                >
                  {{ $t('labels.archive') }}</v-btn
                >
                <v-spacer />
                <v-tooltip bottom>
                  <v-btn
                    @click="addItem"
                    class="events-button-new"
                    slot="activator"
                  >
                    <v-icon color="grey">fa-plus</v-icon>&nbsp;
                    {{ $t('buttons.new') }}
                  </v-btn>
                  <span>{{ $t('tooltips.newEvent') }}</span>
                </v-tooltip>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="dashboard-item" v-if="records.length == 0">
                  <span class="headline" headline v-if="search == ''">{{
                    $t('labels.noResultsEventsFilter')
                  }}</span>
                  <span v-if="search != ''">{{
                    $t('labels.noResultsEventsSearch')
                  }}</span>
                </v-flex>
                <v-flex
                  :key="key"
                  class="dashboard-item"
                  v-for="(event, key) in records"
                  xs12
                >
                  <v-layout row>
                    <v-flex class="dashboard-content">
                      <span
                        @click="editItem(event)"
                        class="headline dashboard-event-title"
                        >{{ event.name }}</span
                      ><br />
                      <span class="subheading content-dates"
                        ><span v-if="event.status == 'completed'"
                          >{{ event.start }} - {{ event.end }} | </span
                        >ID: {{ event.temp_id }}</span
                      ><br />
                      <span
                        :class="{
                          subheading: true,
                          'content-status': true,
                          'status-completed': event.status == 'completed',
                          'status-active': event.status == 'active',
                          'status-archive': event.status == 'archive',
                        }"
                        >{{ $t('statuses.' + event.status) }}</span
                      ><br />
                      <div class="caption">
                        <div
                          :key="key"
                          class="tag-div"
                          v-for="(tag, key) in event.tags"
                        >
                          {{ tag }}
                        </div>
                      </div>
                    </v-flex>
                    <v-flex class="dashboard-actions" style="text-align: right">
                      <v-btn
                        @click="start(event)"
                        icon
                        ripple
                        v-if="
                          event.status == 'published' && activeEvent === null
                        "
                      >
                        <v-icon color="green lighten-1">fa-play-circle</v-icon>
                      </v-btn>
                      <v-btn
                        @click="stop(event)"
                        icon
                        ripple
                        v-if="event.status == 'active'"
                      >
                        <v-icon color="red lighten-1">fa-stop-circle</v-icon>
                      </v-btn>
                      <v-tooltip bottom>
                        <v-btn @click="editItem(event)" icon slot="activator">
                          <v-icon color="grey">fa-edit</v-icon>
                        </v-btn>
                        <span>{{ $t('tooltips.edit') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn @click="cloneItem(event)" icon slot="activator">
                          <v-icon color="grey">fa-clone</v-icon>
                        </v-btn>
                        <span>{{ $t('tooltips.clone') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="event.status === 'completed'">
                        <v-btn @click="getPdf(event)" icon slot="activator">
                          <v-icon color="grey">fa-file-pdf</v-icon>
                        </v-btn>
                        <span>{{ $t('tooltips.downloadEventPdf') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="event.status != 'active'">
                        <v-btn @click="deleteItem(event)" icon slot="activator">
                          <v-icon color="grey">fa-trash</v-icon>
                        </v-btn>
                        <span>{{ $t('tooltips.delete') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="event.status == 'completed'">
                        <v-btn
                          @click="archiveItem(event)"
                          icon
                          slot="activator"
                        >
                          <v-icon color="grey">fa-archive</v-icon>
                        </v-btn>
                        <span>{{ $t('tooltips.archive') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  class="text-xs-center pt-3 pb-3"
                  v-if="Math.ceil(total / perPage) > 1"
                  xs12
                >
                  <v-pagination
                    :length="Math.ceil(total / perPage)"
                    v-model="page"
                  ></v-pagination>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import handle_bad_request_error from '@/helpers/handle_bad_request_error.js'
import handle_session_error from '@/helpers/handle_session_error.js'

// It returns "first" active event or null.
// Hint: There should only be one active event.
function find_active_event(events) {
  for (let i = 0; i < events.length; i++) {
    if (events[i].start !== '' && events[i].end === '') {
      return events[i]
    }
  }

  return null
}

export default {
  name: 'Events',

  data() {
    return {
      publicPath: process.env.BASE_URL,
      records: [],
      search: '',
      category: '',
      perPage: 10,
      page: 1,
      total: 0,
      totalAll: 0,
      initialLoad: false,
      deleteDialog: {
        show: false,
        eventId: null,
        generatedPin: '',
        enteredPin: '',
      },
      activeEvent: null,
    }
  },

  watch: {
    search: function () {
      this.reloadData()
    },
    page: function () {
      this.reloadData()
    },
  },

  methods: {
    start(event) {
      this.$verify(this.$t('alerts.startEvent'), result => {
        if (result) {
          console.log(event)
          let payload = {
            sms_authentication: event.sms_authentication,
            number_of_voters: event.voterCount,
          }
          this.$APICall(
            'post',
            'EVENTS',
            '/check-tokens',
            payload,
            data => {
              if (data.success) {
                this.$APICall(
                  'get',
                  'EVENTS',
                  '/' + event.id + '/start',
                  [],
                  () => {
                    this.reloadData()
                  },
                  true,
                  error => {
                    handle_bad_request_error(error, this.$verify, this.$i18n)
                    handle_session_error(
                      error,
                      this.$store,
                      this.$router,
                      this.$prompt
                    )
                  }
                )
              } else {
                this.$alert(this.$t('alerts.tokensNotAvailable'))
              }
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    stop(event) {
      this.$verify(this.$t('alerts.stopEvent'), result => {
        if (result) {
          this.$APICall(
            'get',
            'EVENTS',
            '/' + event.id + '/stop',
            [],
            () => {
              this.reloadData()
            },
            true,
            error => {
              handle_bad_request_error(error, this.$verify, this.$i18n)
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    selectCategory(category) {
      this.category = category
      this.reloadData()
    },
    addItem() {
      this.$router.push('/events/0')
    },
    reloadData() {
      let payload = {
        search: this.search,
        category: this.category,
        per_page: this.perPage,
        page: this.page,
      }

      this.$APICall(
        'get',
        'EVENTS',
        '',
        payload,
        data => {
          this.total = data.total
          this.totalAll = data.total_all
          this.records = data.records

          this.activeEvent = find_active_event(this.records)

          this.$nextTick(() => {
            this.initialLoad = true
          })
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },
    deleteItem(item) {
      this.deleteDialog.eventId = item.id
      this.deleteDialog.generatedPin = Math.floor(Math.random() * 800 + 100)
      this.deleteDialog.show = true
    },

    getPdf(event) {
      this.$APICall(
        'get',
        'EVENTS',
        `/${event.id}/pdf`,
        {},
        data => {
          window.open(data.pdf_link)
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    deleteDialogClose() {
      this.deleteDialogReset()
    },
    deleteDialogSave() {
      let message = ''

      if (this.deleteDialog.generatedPin != this.deleteDialog.enteredPin) {
        message += this.$t('alerts.pinMatch') + '<br />'
      }

      if (message == '') {
        let vm = this
        this.$APICall(
          'delete',
          'EVENTS',
          '/' + this.deleteDialog.eventId,
          {},
          function () {
            vm.reloadData()
            vm.deleteDialogClose()
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
    deleteDialogReset() {
      this.deleteDialog = {
        show: false,
        eventId: null,
        generatedPin: '',
        enteredPin: '',
      }
    },
    cloneItem(item) {
      this.$verify(this.$t('alerts.cloneQuestion'), result => {
        if (result) {
          this.$APICall(
            'post',
            'EVENTS',
            '/clone/' + item.id,
            {},
            data => {
              this.$router.push('/events/' + data.preview_token + '/1')
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },
    editItem(item) {
      this.$router.push('/events/' + item.preview_token)
    },
    archiveItem(item) {
      this.$verify(this.$t('alerts.archiveQuestion'), result => {
        if (result) {
          var vm = this
          this.$APICall(
            'post',
            'EVENTS',
            '/archive/' + item.id,
            {},
            function () {
              vm.reloadData()
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },
  },
  mounted() {
    this.reloadData()
  },
}
</script>

<style scoped>
.dashboard-actions {
  max-width: 260px !important;
}

.dashboard-status {
  max-width: 70px !important;
  padding-top: 12px;
  height: 48px;
}

.dashboard-content {
  padding-left: 10px;
  color: #707070 !important;
}

/* Disabled because it was preventing colors on icons. */
/* .dashboard-actions button i {
		color: #707070 !important;
	} */

.dashboard-content .headline {
  font-weight: bold;
}

.dashboard-content .content-dates {
  font-size: 14px !important;
  color: #b4b4b4 !important;
}

.dashboard-content .content-status {
  font-size: 14px !important;
  color: #b4b4b4;
  font-weight: bold !important;
}

.dashboard-item {
  padding-top: 47px;
  padding-bottom: 23px;
  border-bottom: 1px #d5d5d5 dashed;
}

.tag-div {
  float: left;
  padding: 5px;
  margin: 5px;
  background-color: #ffffff;
  border: 1px solid #b4b4b4;
  font-weight: bold;
  border-radius: 5px;
  color: #b4b4b4;
}

.tag-div:first-of-type {
  margin-left: 0px;
}

.search-field {
  max-width: 300px;
}

::v-deep .events-main-card {
  background: transparent !important;
}

::v-deep .events-buttons-header {
  border-bottom: 2px solid #e8e8e8;
}

::v-deep .events-category {
  color: #acacac !important;
  box-shadow: none !important;
  margin: 0px !important;
  padding: 18px !important;
  padding-bottom: 18px !important;
  height: 80px !important;
  border-radius: 0px !important;
  background: transparent !important;
}

::v-deep .events-category-active {
  color: #707070 !important;
  border-bottom: 4px solid #6f6f6f;
}

::v-deep .events-button-new {
  background-color: #6f6f6f !important;
  color: #ffffff !important;
  height: 44px !important;
  margin-top: 18px !important;
  margin-bottom: 18px !important;
}

::v-deep .events-button-new i {
  color: #88c143 !important;
}

.status-completed {
  color: #93be56 !important;
}

.status-active {
  color: #4694dd !important;
}

.status-archive {
  color: #bf6f6d !important;
}

::v-deep .headline {
  color: #707070 !important;
}

.empty-overlay {
  min-height: 570px;
  height: calc(100vh - 90px);
  width: 100vw;
  margin-left: -24px;
  margin-right: -24px;
  margin-bottom: -100px;
  text-align: center;
  padding: 20px;
  padding-top: 200px;
  color: #4b4b4b;
}

.empty-inner {
  margin-left: auto;
  margin-right: auto;
  max-width: 800px;
}

.empty-inner h1 {
  font-size: 32px;
  margin-bottom: 30px;
}

.empty-inner p {
  margin-bottom: 60px;
}

.empty-inner button {
  font-size: 20px;
  min-height: 60px;
}

.dashboard-event-title {
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .empty-overlay {
    padding-top: 20px;
  }
}

@media only screen and (max-width: 960px) {
  .empty-overlay {
    margin-left: -16px;
  }
}
</style>
